import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  general: {
    email: "jessiereyez@iyk.app",
    name: "Jessie Reyez",
    baseUrl: "https://jessiereyez.iyk.app",
    shopUrl: "https://shop.jessiereyez.com",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://instagram.com/jessiereyez",
    },
    {
      label: "YouTube",
      logo: UI.Icon.Youtube,
      href: "https://www.youtube.com/user/JessieReyez",
    },
    {
      label: "TikTok",
      logo: UI.Icon.Tiktok,
      href: "https://tiktok.com/@jessiereyez",
    },
    {
      label: "Discord",
      logo: UI.Icon.Discord,
      href: "https://discord.com/invite/jessiereyez",
    },
    {
      label: "Facebook",
      logo: UI.Icon.Facebook,
      href: "https://www.facebook.com/MusicJessieReyez",
    },
    {
      label: "X",
      logo: UI.Icon.X,
      href: "https://x.com/jessiereyez",
    },
    {
      label: "Threads",
      logo: UI.Icon.Threads,
      href: "https://www.threads.com/@jessiereyez",
    },
    {
      label: "Spotify",
      logo: UI.Icon.Spotify,
      href: "https://open.spotify.com/artist/3KedxarmBCyFBevnqQHy3P?si=9f0MIM-yRMW3e74vJwSRnQ",
    },
    {
      label: "Apple Music",
      logo: UI.Icon.AppleMusic,
      href: "https://music.apple.com/us/artist/jessie-reyez/1043591612",
    },
  ],
})

interface Config {
  general: {
    email: string
    name: string
    baseUrl: string
    shopUrl: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
